import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * `prefers-reduced-motion: reduce`, riletto quando cambia. ⚠️ `matchMedia` puo' mancare (jsdom) o lanciare (WebView strane): senza,
 * vale «movimento normale». Lo usano le emote dell'avatar al tavolo (I-581): col movimento ridotto niente video, poster ed emoji.
 */
export function useMovimentoRidotto(): boolean {
  const leggi = (): MediaQueryList | null => {
    try {
      return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null;
    } catch {
      return null;
    }
  };
  const [ridotto, setRidotto] = useState(() => leggi()?.matches ?? false);
  useEffect(() => {
    const mq = leggi();
    if (!mq) return;
    const onChange = () => setRidotto(mq.matches);
    onChange();
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);
  return ridotto;
}
